// @ts-nocheck
/* eslint-disable */
import { Scene } from "~/route/globals";

const MAX_3D_POINTS_LENGTH = 25000;

export default class M3D {
	constructor(mapInst) {
		this._map = mapInst;
		this._3dlayer = null;
		this._3dlayerActive = null;
		this._geometryLines = [];

		Scene.addListener("provider-change", event => {
			let data = event.data;

			if (data.newProvider == "map") {
				if (this._3dlayer) {
					Scene.removeLayer(this._3dlayer);
					this._3dlayer.destroy();
					this._3dlayer = null;

					Scene.removeLayer(this._3dlayerActive);
					this._3dlayerActive.destroy();
					this._3dlayerActive = null;
				}
			}
		});
	}

	destroy() {
		this.clear();
	}

	clear() {
		this._geometryLines.length = 0;

		if (this._3dlayer) {
			Scene.removeLayer(this._3dlayer);
			this._3dlayer.destroy();
			this._3dlayer = null;

			Scene.removeLayer(this._3dlayerActive);
			this._3dlayerActive.destroy();
			this._3dlayerActive = null;
		}
	}

	show(geometry) {
		if (!geometry) { return; }

		this._geometryLines = [];

		geometry.forEach((g, i) => {
			if (g && g.length) {
				this._geometryLines[i] = [];
				if (g.length > MAX_3D_POINTS_LENGTH) {
					this._geometryLines[i] = [Mapy.Util.IP.resizePath(g, {
						count: MAX_3D_POINTS_LENGTH,
						returnWGS84: true
					})];
				}
				else {
					this._geometryLines[i] = [g.map(coord => {
						return coord.toWGS84();
					})];
				}
			}
			else {
				this._geometryLines[i] = [];
			}
		});

		if (Scene.isM3dActive()) {
			this._show3DGeometry();
		}
	}

	_show3DGeometry() {
		if (this._3dlayer) {
			Scene.removeLayer(this._3dlayer);
			this._3dlayer.destroy();
			this._3dlayer = null;

			Scene.removeLayer(this._3dlayerActive);
			this._3dlayerActive.destroy();
			this._3dlayerActive = null;
		}

		let geometries = [];
		const state = Mapy.CML.state;
		if (this._geometryLines.length > 1) {
			this._geometryLines.forEach((g, i) => {
				if (i != state.route.index) {
					geometries.push(g[0]);
				}
			});
		}

		if (this._geometryLines.length) {
			this._3dlayer = Scene.createLayerFree("route", geometries, {
				lineColor: [69, 76, 84, 153],
				outlineColor: [255, 255, 255, 102],
				lineOffset: [-0.19, 0, 0],
				outlineOffset: [-0.19, 0, 0]
			});

			this._3dlayerActive = Scene.createLayerFree("routeActive", this._geometryLines[this._geometryLines.length === 1 ? 0 : state.route.index], {
				lineColor: [0, 51, 255, 153],
				outlineColor: [255, 255, 255, 102],
				lineOffset: [-0.19, 0, 0],
				outlineOffset: [-0.19, 0, 0]
			});
			Scene.addLayer(this._3dlayerActive);
			Scene.addLayer(this._3dlayer);
		}
	}
}
